import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';
import { ToastsService } from 'projects/b2c/src/app/core/services/toasts.service';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../../hotel.service';

@Component({
  selector: 'app-hotel-payment-status',
  templateUrl: './hotel-payment-status.component.html',
  styleUrls: ['./hotel-payment-status.component.scss']
})
export class HotelPaymentStatusComponent implements OnInit {

  appReference: any;
  orderId: any;
  booking_source: any;
  loading: boolean = false;
  currentUser: any;
  flight: any;
  airline_logo: string = '';
  confirmedData: any;
  showConfirmTicket: boolean = true;
  private subSink = new SubSink();
  hotelDetails: any;
  paxDetails: any;
  roomDetails: any;
  bookingDetails: any;
  leadPax: any;
  totalFare: any = 0;
  nights: any;
  bookingSource: any;
  primaryColour: any;
  secondaryColour: any;
  loadingTemplate: any;
  status:any;
  custData: any;
  constructor(private router: Router,
    private swalService: SwalService,
    private route: ActivatedRoute,
    private toastsService: ToastsService,
    private hotelService: HotelService,
    private util: UtilityService,
    private apiHandlerService: ApiHandlerService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    ) { }

 
  ngOnInit(): void {
    const customer = localStorage.getItem("hotelCommitBookingResponse");
    const orderId = localStorage.getItem("orderId");
    this.orderId = orderId;
    this.custData = JSON.parse(customer);
    this.paymentCheckout();
  }


  paymentCheckout() {
    this.subSink.sink = this.apiHandlerService.apiHandler('transactionStatus', 'post', {}, {}, {
      order_id:this.orderId,
    }).subscribe(
      (resp) => {
        if (resp.statusCode == 201 || resp.statusCode == 200) {
          if (resp.data == true) {
            this.toastsService.toast({ 'type': 'success', 'text': 'Payment successful' });
            this.reservation();
          } else {
            this.goToVoucher(this.custData.BookingDetails.AppReference);
            this.toastsService.toast({ 'type': 'error', 'text': 'Payment Failed' });
          }
        }
      },
      (error) => {
        this.goToVoucher(this.custData.BookingDetails.AppReference);
      }
    );
  }
  


  reservation() {
    this.hotelService.loading.next(true);
    this.subSink.sink = this.apiHandlerService.apiHandler('reservation', 'post', {}, {}, {
        AppReference:  this.custData.BookingDetails.AppReference,
        booking_source: this.custData.BookingDetails.booking_source,
        UserType: 'B2C',
    }).subscribe(resp => {
        if (resp.statusCode == 200) {
          this.loading=false;
          // this.updateSubAgent(resp);
          // this.deductFromWallet(this.appReference);
         this.hotelService.hotelConfirmationData.next(resp.data);
          this.router.navigate(['/hotel-voucher'], { queryParams: { AppReference: this.custData.BookingDetails.AppReference, OrderId: this.orderId, BookingSource: this.custData.BookingDetails.booking_source } });
        } else {
            setTimeout(() => {
                this.router.navigate(['/']);
            }, 100);
        }
    }, err => {
        console.error(err);
        this.goToVoucher(this.custData.BookingDetails.AppReference);
    })
    this.cdr.detectChanges();
    this.hotelService.loading.next(false);
}

intializeValue() {
    this.subSink.sink = this.hotelService.hotelConfirmationData.subscribe(data => {
        this.hotelDetails = data;
        this.paxDetails = this.hotelDetails.BookingPaxDetails;
        this.bookingDetails = this.hotelDetails.BookingDetails;
        this.leadPax = this.paxDetails[0];
        this.roomDetails = this.hotelDetails.BookingItineraryDetails;
        this.roomDetails.forEach(element => {
            this.totalFare += element.TotalFare;
        });
        this.nights = this.util.noOfNights(this.bookingDetails.HotelCheckIn, this.bookingDetails.HotelCheckOut);
        this.loading = false;
        this.cdr.detectChanges();
    })
}

goToVoucher(appRef: any) {
  this.router.navigate(['/hotel-voucher'], { queryParams: { AppReference: appRef, booking_source: this.custData.BookingDetails.booking_source} });
}
}
